import React, { useState, useEffect } from "react"
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import "./css/style.css"
import "./css/font-awesome.min.css"
import "./css/magnific-popup.css"
import Nav from "./components/Nav"
import Home from "./pages/Home"
import Skills from "./pages/Skills"
import Works from "./pages/Works"
import About from "./pages/About"
import Qualification from "./pages/Qualification"
import Contact from "./pages/Contact"
import Footer from "./pages/Footer"
import LoadingScreen from "./components/LoadingScreen"

function App() {
  const [load, setLoad] = useState(true)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoad(false)
    }, 3000)

    return () => clearTimeout(timeout)
  }, [])

  return (
    <>
      {load ? (
        <LoadingScreen />
      ) : (
        <>
          <Nav />
          <Home />
          <About />
          <Qualification />
          <Skills />
          <Works />
          <Contact />
          <Footer />
        </>
      )}
      <Analytics />
      <SpeedInsights />
    </>
  )
}

export default App
